import { ApolloError } from 'apollo-client';
import { AmberHoc, AmberHocProps } from '../../../util';
import { FanModelFilter, FanModelResult, withGetGrainFanModels as HOC } from '../__generated';

export type WithGetGrainFanModelsHocOwnProps = {
  fan_model_filter: FanModelFilter[];
  loading?: boolean;
  onError?: (error: ApolloError) => void;
};
export type WithGetGrainFanModelsHocChildProps = {
  get_grain_fan_models_loading: boolean;
  grain_fan_models: FanModelResult[] | any;
  refetch_grain_fan_models: () => Promise<any>;
};
export const withGetGrainFanModelsHoc: AmberHoc<
  WithGetGrainFanModelsHocOwnProps,
  WithGetGrainFanModelsHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<
      WithGetGrainFanModelsHocOwnProps,
      WithGetGrainFanModelsHocChildProps,
      typeof component
    >,
    WithGetGrainFanModelsHocChildProps
  >({
    options: ({ fan_model_filter, onError }) => ({
      onError,
      variables: { fan_model_filter },
      errorPolicy: onError ? 'all' : 'none',
      fetchPolicy: 'network-only',
      context: { important: true }, // flag to prevent from graphql batching
    }),
    props: ({ data, ownProps: { loading } }) => {
      if (!data || data.loading) {
        return {
          get_grain_fan_models_loading: true,
          refetch_grain_fan_models: () => Promise.resolve(),
          grain_fan_models: [],
        };
      }

      return {
        get_grain_fan_models_loading: loading || false,
        refetch_grain_fan_models: data.refetch,
        grain_fan_models: data.grain_fan_models || [],
      };
    },
  })(component as any);
